import { reducer as notificationsReducer } from "reapop";
import {
    authorizedAppsHasErrored,
    authorizedAppsIsLoading,
    authorizedApps,
} from "./authorizedApps/authorizedAppsReducer";
import {
    authenticateUserHasErrored,
    authenticateUserIsLoading,
    authenticatedUser,
    activeUser,
    users,
} from "./users/usersReducer";
import { locationTitle, layout, context, tableState } from "./contextInfos/contextInfosReducer";
import { synchro } from "./synchro/synchroReducer";
import { info } from "./info/infoReducer";
import { tiers } from "./tiers/tiersReducer";
import { image } from "./image/imageReducer";
import { serviceWorker } from "./serviceWorker/swReducer";
import { affair } from "./affair/affairReducer";
import { parameter, indexedDbTables } from "./parameter/parameterReducer";

export default {
    notifications: notificationsReducer(),
    layout,
    context,
    tableState,

    authorizedAppsHasErrored,
    authorizedAppsIsLoading,
    authorizedApps,
    serviceWorker,

    authenticateUserHasErrored,
    authenticateUserIsLoading,
    authenticatedUser,
    activeUser,
    users,

    locationTitle,

    synchro,
    info,

    tiers,
    affair,
    image,

    parameter,
    indexedDbTables,
};
